import { TableFilterConfig } from "src/docuclipper/DocuclipperTypes";
import { ExternalFilter } from "src/redux/reducers/ExternalFilter";

export const convertExternalFiltersToTableFilterConfig = (
  externalFilters: ExternalFilter["externalFilters"]
): TableFilterConfig[] => {
  // console.log({ externalFilters });

  const tableFilterConfigs: TableFilterConfig[] = Object.entries(
    externalFilters
  ).map(([key, { filterType, type, filterValue, filterValueTo }]) => ({
    field: key,
    type,
    value: filterValue,
    operator: filterType as any,
    valueFrom: filterValue,
    valueTo: filterValueTo,
  }));

  return tableFilterConfigs;
};

export const convertFilterModel = (params): TableFilterConfig[] => {
  return Object.entries(params.filterModel).map(
    ([field, filter]: [string, any]) => {
      // Get the actual filter type from the filter object
      const filterType = filter.filterType || "text"; // Default to 'text' if filterType is not specified
      const operationType = filter.type; // This is the operation (equals, contains, lessThan, etc.)

      // Initialize the filter object
      const filterOutput = {
        field,
        operator: operationType, // The operation (equals, contains, lessThan, etc.)
        valueFrom: undefined,
        valueTo: undefined,
        value: undefined,
      };

      if (filterType === "number") {
        // Handle number filters
        if (operationType === "inRange") {
          filterOutput.valueFrom = filter.filter; // For range filters
          filterOutput.valueTo = filter.filterTo;
        } else if (operationType === "blank" || operationType === "notBlank") {
          filterOutput.value = undefined; // No specific value for blank/not blank
        } else {
          filterOutput.value = filter.filter; // Single value filters
        }
      } else if (filterType === "date") {
        // Handle date filters
        if (operationType === "inRange") {
          filterOutput.valueFrom = filter.dateFrom; // Date filters use dateFrom
          filterOutput.valueTo = filter.dateTo; // and dateTo
        } else if (operationType === "blank" || operationType === "notBlank") {
          filterOutput.value = undefined; // No specific value for blank/not blank
        } else {
          filterOutput.value = filter.dateFrom; // Single value date filters use dateFrom
        }
      } else {
        // Handle text filters and other types
        filterOutput.value = filter.filter; // Default case
      }

      return filterOutput;
    }
  );
};

export const convertSortModel = (sortModel: any[]) => {
  return sortModel.map((sort) => ({
    field: sort.colId,
    direction: sort.sort.toUpperCase(),
  }));
};
